import {
    WikiDisableUserFeatureArgs,
    WikiEnableUserFeatureArgs,
} from '~shared/schema/wiki/actions/user-features';

import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';
import {i18n} from '~ui/components/AsideNavigation/i18n';

const errorHandler = makeThunkErrorHandler({
    name: 'update-feature-error',
    title: i18n('settings-update-error'),
    content: i18n('settings-update-error-description'),
});

export const disableUserFeature = createThunk(
    'user-feature/disable',
    async ({feature}: WikiDisableUserFeatureArgs, thunkAPI) => {
        const sdk = thunkAPI.extra.sdk;

        return sdk.wiki.disableUserFeature({feature}).catch(errorHandler);
    },
);

export const enableUserFeature = createThunk(
    'user-feature/enable',
    async ({feature}: WikiEnableUserFeatureArgs, thunkAPI) => {
        const sdk = thunkAPI.extra.sdk;

        return sdk.wiki.enableUserFeature({feature}).catch(errorHandler);
    },
);

export const getUserFeatures = createThunk('user-feature/get', async (_args, {extra: {sdk}}) => {
    return sdk.wiki.getUserFeatures().catch(
        makeThunkErrorHandler({
            name: 'get-features',
            title: i18n('settings-get-error'),
        }),
    );
});
